import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=4dda125f&"
import script from "./Interview.vue?vue&type=script&lang=ts&"
export * from "./Interview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports